import React from "react";

const NavRobotIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="none"
      className={className}
    >
      <path
        d="M14.0715 0.751029H8.50608C7.8333 0.750759 7.16705 0.883058 6.54541 1.14037C5.92377 1.39767 5.35893 1.77495 4.88315 2.25063C4.40737 2.72632 4.02998 3.29109 3.77254 3.91268C3.51511 4.53426 3.38268 5.20048 3.38281 5.87327V11.4387C3.38254 12.1116 3.51488 12.7779 3.77225 13.3996C4.02962 14.0214 4.40699 14.5862 4.88278 15.062C5.35858 15.5378 5.92347 15.9152 6.54517 16.1726C7.16688 16.4299 7.83321 16.5623 8.50608 16.562H14.0715C14.7444 16.5623 15.4108 16.4299 16.0325 16.1726C16.6542 15.9152 17.2191 15.5378 17.6949 15.062C18.1706 14.5862 18.548 14.0214 18.8054 13.3996C19.0628 12.7779 19.1951 12.1116 19.1948 11.4387V5.87327C19.1951 5.2004 19.0628 4.53407 18.8054 3.91236C18.548 3.29066 18.1706 2.72576 17.6949 2.24997C17.2191 1.77418 16.6542 1.39681 16.0325 1.13944C15.4108 0.882063 14.7444 0.74973 14.0715 0.75V0.751029Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M19.1123 12.3453H20.7772C21.0568 12.3453 21.3249 12.2342 21.5226 12.0365C21.7203 11.8389 21.8313 11.5707 21.8313 11.2912V6.02086C21.8313 5.74131 21.7203 5.4732 21.5226 5.27553C21.3249 5.07785 21.0568 4.9668 20.7772 4.9668H19.1113M3.47 12.3453H1.80407C1.66564 12.3453 1.52858 12.318 1.40069 12.265C1.27281 12.212 1.15661 12.1344 1.05873 12.0365C0.96085 11.9386 0.883208 11.8224 0.830236 11.6946C0.777264 11.5667 0.75 11.4296 0.75 11.2912V6.02086C0.75 5.74131 0.861053 5.4732 1.05873 5.27553C1.2564 5.07785 1.52451 4.9668 1.80407 4.9668H3.47"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M1.79688 4.96821V0.751953M20.7803 4.96821L20.77 0.751953M8.12127 5.32814V8.10265M14.4457 5.32814V8.10265M9.17533 12.3467H13.3916"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NavRobotIcon;
